<template>
    <div class="mit-page">
        <BaseMitLoading class="mit-progress" :show="loading" :absolute="true"/>
        <v-container fluid>
            <v-snackbar :color="status.color" min-width="0" v-model="status.display" :timeout="status.timeout">
                <b>{{ status.message }}</b>
          </v-snackbar>
            <v-row>
              <v-col cols="12" class="d-flex">
                <v-card class="mit-info-card" style="width:100%">
                    <v-card-title>Upload Spaces</v-card-title>
                    <v-card-subtitle class="caption">Upload a new map from facilities.</v-card-subtitle>
                    <v-divider></v-divider>

                    <v-card-text>

                        <v-stepper v-model="wizardStep" flat outlined>
                            <v-stepper-header>
                              <v-stepper-step :complete="wizardStep > 1" step="1">Verify Files</v-stepper-step>

                              <v-divider></v-divider>

                              <v-stepper-step :complete="wizardStep > 2" step="2">Upload JSON</v-stepper-step>

                              <v-divider></v-divider>

                              <v-stepper-step :complete="wizardStep > 3" step="3">Upload DXF Floors</v-stepper-step>

                              <v-divider></v-divider>

                              <v-stepper-step :complete="wizardStep > 4" step="4">Preview</v-stepper-step>

                              <v-divider></v-divider>

                              <v-stepper-step step="5">Save</v-stepper-step>
                            </v-stepper-header>

                            <v-stepper-items>

                              <v-stepper-content step="1">
                                <v-card flat class="mb-12" height="200px">
                                    <v-card-text>
                                        Upload requires getting several files from facilities.
                                        <v-list-item two-line>
                                          <v-list-item-content>
                                            <v-list-item-title>1. JSON Building File</v-list-item-title>
                                            <v-list-item-subtitle class="text-wrap">This is a file that contains all the space information such as room dimensions, ids, names, areas, etc. It should contain all the floors for a building.</v-list-item-subtitle>
                                          </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item two-line>
                                          <v-list-item-content>
                                            <v-list-item-title>2. DXF Architecture Files (one for each floor). </v-list-item-title>
                                            <v-list-item-subtitle class="text-wrap">This is a file that contains all the floor structure information as well as doors and windows. There should be 1 file for each floor.</v-list-item-subtitle>
                                          </v-list-item-content>
                                        </v-list-item>
                                    </v-card-text>
                                </v-card>

                                <v-btn text disabled>Cancel</v-btn>
                                <v-btn color="primary" @click="wizardStep = 2">Next</v-btn>
                              </v-stepper-content>


                              <v-stepper-content step="2">
                                <v-card flat class="mb-12" height="200px">
                                    <v-card-title class="text-h7">
                                        <p>Select the JSON building file.</p>
                                    </v-card-title>
                                    <v-card-text>
                                        <input id="uploadFileJSON" type="file" accept=".json" v-on:change="importJSONFile">
                                    </v-card-text>
                                    <v-card-text v-if="JSONModel && JSONModel.spacesTree.length > 0">
                                            <v-list-item two-line class="pa-0">
                                                <v-list-item-icon class="pt-3 mr-2">
                                                    <v-icon large>mdi-office-building-outline</v-icon>
                                                </v-list-item-icon>
                                                  <v-list-item-content class="">
                                                    <v-list-item-title>Building {{JSONModel.spacesTree[0].mitId}}</v-list-item-title>
                                                    <v-list-item-subtitle class="text-wrap">Floors {{JSONModel.spacesTree[0].children.length}}</v-list-item-subtitle>
                                                  </v-list-item-content>
                                            </v-list-item>
                                    </v-card-text>
                                </v-card>

                                <v-btn text @click="cancel">Cancel</v-btn>
                                <v-btn color="primary" :disabled="!(JSONModel && JSONModel.spacesTree.length > 0)" @click="wizardStep = 3">Next</v-btn>
                              </v-stepper-content>


                              <v-stepper-content step="3">
                                  <v-card flat class="mb-12 mx-auto">
                                      <v-card-text  v-if="JSONModel">
                                          Upload the DXF building files.
                                          <div v-for='(floor, index) in JSONModel.spacesTree[0].children' :key='floor.level'>
                                              Level {{floor.level}}: <input id="uploadFileDXF" v-if="dxfUploadedCount >= index" type="file" accept=".dxf" v-on:change="importDXFFile($event, floor.level,JSONModel.spacesTree[0].mitId)">
                                          </div>
                                          <!-- <input id="uploadFileDXF" type="file" accept=".json" v-on:change="importJSONFile"> -->
                                      </v-card-text>
                                  </v-card>

                                  <v-btn text @click="cancel">Cancel</v-btn>
                                  <v-btn color="primary" @click="generatePreview(); wizardStep = 4">Next</v-btn>
                              </v-stepper-content>


                              <v-stepper-content step="4">
                                  <v-card flat class="mb-12">
                                      <v-card-text v-if="showPreview">
                                        <div class="text-right">
                                            <div style="display: inline-flex">
                                                <v-checkbox title="Text to show" class="pa-0 ma-0" v-model="showAlignOption" label="Advanced: align controls"></v-checkbox>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon class="pa-0 ma-0 pb-6 pl-2" color="primary" dark v-bind="attrs" v-on="on">
                                                        mdi-help-circle-outline
                                                        </v-icon>
                                                    </template>
                                                    <span>This is an advanced function only needed the for the very first version a building is added to the application.</span>
                                                </v-tooltip>
                                            </div>
                                        </div>
                                          <MitSpacesMapPreview :alignOverride="alignOverride" :showAlignOption="showAlignOption" :defaultLevel="currentLevelOverride" :mapGeoJson="previewMapModel" :info="previewSpacesMapInfo" :spacesList="previewSpacesList" @adjusted="adjust"></MitSpacesMapPreview>
                                      </v-card-text>
                                  </v-card>

                                  <v-btn text @click="cancel">Cancel</v-btn>
                                  <v-btn color="primary" @click="wizardStep = 5">Next</v-btn>
                              </v-stepper-content>


                              <v-stepper-content step="5">
                                  <v-card flat class="mb-12" height="200px">
                                      <v-card-text>
                                          Click the Finish button to save the building.<br>
                                          <b>NOTE:</b> This may take some time due to the size of the building data.<br><br>
                                          <v-btn color="primary" :disabled="uploading" @click="importSave">FINISH</v-btn>
                                      </v-card-text>
                                  </v-card>

                                  <v-btn text @click="cancel">Cancel</v-btn>
                                  <v-btn color="primary" disabled>Next</v-btn>
                              </v-stepper-content>
                            </v-stepper-items>
                          </v-stepper>


                    </v-card-text>

                </v-card>
              </v-col>
            </v-row>
        </v-container>
  </div>
</template>


<script>
import MitSpacesUploadService from '../../services/MitSpacesUploadService.js';
import MitGisJSONService from '../../services/MitGisJSONService.js';
import MitGisDXFService from '../../services/MitGisDXFService.js';
import MitMapPreviewService from '../../services/MitMapPreviewService.js';

import MitSpacesMapPreview from '../../components/MitSpacesMapPreview.vue';
import BaseMitLoading from '../../../base/components/BaseMitLoading.vue';


export default {
  name: 'MitAdminSpacesUploadPage',
  components: {
    MitSpacesMapPreview,
    BaseMitLoading
  },
  data: function() {
    return {
        wizardStep:1,
        uploading:false,
        loading:false,
      status:{
        display:false,
        timeout:3000,
        message:'Saved!',
        color:'primary'
      },
      previewMapModel:null,
      previewSpacesMapInfo:{
          levels:[],
          spaceTypes:[],
          spaceUse:[],
          orgs:[]
      },
      previewSpacesList:[],
      dxfOriginalData:{},
      currentLevelOverride:null,
      showAlignOption:false,
      alignOverride:{
        angle:-24.7,
        x:766723.383644,
        y:2956761.05585,
      },
      showPreview:false,
      dxfModels:{},
      dxfUploadedCount:0,
      JSONModel:null,
      wldModel:null,
      importResult: {
        show: false,
        showDetails:false,
        message:'',
        status:'success',
        data:null
      },
      mitSpacesUploadService: new MitSpacesUploadService(),
      mitGisJSONService: new MitGisJSONService(),
      mitGisDXFService: new MitGisDXFService(),
      mitMapPreviewService: new MitMapPreviewService()
    }
  },
  mounted(){

  },
  methods : {
    clearData(){
        this.JSONModel = null;

        this.previewMapModel = null;
        this.previewSpacesMapInfo = {
            levels:[],
            spaceTypes:[],
            spaceUse:[],
            orgs:[]
        };
        this.previewSpacesList = [];
        this.dxfModels = {};
        this.dxfOriginalData = {};
        this.showPreview = false;
        this.uploading = false;
    },
    cancel(){
        this.wizardStep = 1;
        document.getElementById('uploadFileJSON').value = "";
        this.clearData();
    },
    importSave(){
        this.uploading = true;
        this.loading = true;
        //merge in the DXF models and floor coordinates (structure) into the tree model
        let level;
        for(let x = 0; x < this.JSONModel.spacesTree[0].children.length; x++){
            level = this.JSONModel.spacesTree[0].children[x].level;

             if (this.dxfModels.hasOwnProperty(level)) {
                 //add the floor coordinates, which is basically all the structure information.
                 this.JSONModel.spacesTree[0].children[x].geometryCoordinates = this.dxfModels[level].floorCoordinates;
                 //merge in the space models from the dxf file, this is currently doors and windows, to the proper floor
                 this.JSONModel.spacesTree[0].children[x].children = this.JSONModel.spacesTree[0].children[x].children.concat(this.dxfModels[level].spaces);
             }
        }
        this.mitSpacesUploadService.uploadJSON(this.JSONModel.spacesTree[0])
            .then((buildingSettings) => {
                this.loading = false;
                this.status.display = true;
                this.clearData();
                this.wizardStep = 1;
            })
            .catch((error)=>{
                console.log('Error importing building settings', error);
                this.loading = false;
                this.status.message = 'An error occurred trying to import the building.';
                this.status.display = true;
                this.status.color = 'red';
                this.loadingBuildings = false;
                this.wizardStep = 1;
            });
    },
    readFile(filePath){
      return new Promise ((resolve, reject) => {
        var reader = new FileReader();
        reader.onload = (event) => {
            //returns file contents as string
            return resolve(event.target.result);
        }
        reader.onerror = (evt) => {
            return reject('Error loading file:', filePath)
        }
        reader.readAsText(filePath);
       });
   },
   adjust(model){
    //    let promisesAdjust = [];
    //    let currentPromise;
       //keep track of what level the user selected for ease of use during reload, where level will reset
       this.currentLevelOverride = model.level;

       //this should clear the map and init it again. Heavy handed but easier for now.
       this.previewMapModel = null;
       this.showPreview = false;

           this.mitGisDXFService.extractMapData(this.dxfOriginalData[model.level], model.level, this.JSONModel.spacesTree[0].mitId,
               { 
                    angle:model.angle,
                    x:model.x,
                    y:model.y
               })
               .then( (dxfMapInfo)=>{
                   this.dxfModels[model.level] = dxfMapInfo;
                   this.generatePreview();
               })
               .catch( (error) => {
                   console.log('Error Adjusting', error);
               });

   },
   generatePreview(){

       this.previewSpacesMapInfo = {
           levels:[],
           spaceTypes:[],
           spaceUses:[],
           orgs:[]
       };
       this.previewSpacesList = [];

       // this.spacesMapInfo = this.JSONModel.info;
       // this.spacesList = this.JSONModel.spacesList;

       //Add the JSON spaces map info
       this.previewSpacesMapInfo.levels = this.JSONModel.info.levels;
       this.previewSpacesMapInfo.orgs = this.JSONModel.info.orgs;

       //These are going to be lists merged from DXF map info so lets create new ones in case
       //we need to merge these again
       for(let x = 0; x < this.JSONModel.info.spaceTypes.length; x++){
           this.previewSpacesMapInfo.spaceTypes.push(this.JSONModel.info.spaceTypes[x]);
       }
       for(let x = 0; x < this.JSONModel.info.spaceUses.length; x++){
           this.previewSpacesMapInfo.spaceUses.push(this.JSONModel.info.spaceUses[x]);
       }
       for(let x = 0; x < this.JSONModel.spacesList.length; x++){
           this.previewSpacesList.push(this.JSONModel.spacesList[x]);
       }
       let geoJSON = {
           type: "FeatureCollection",
           features: []
       };
       //combine all the geojson in the dxf models that we have
       for (let level in this.dxfModels) {
           if (this.dxfModels.hasOwnProperty(level)) {
               geoJSON.features = geoJSON.features.concat(this.dxfModels[level].geoJSON.features);
           }
       }
       //combine all the geojson from the JSON file
       geoJSON.features = geoJSON.features.concat(this.JSONModel.geoJSON.features);

       this.previewMapModel = this.mitMapPreviewService.convertGeoJSONtoMapModel(geoJSON);

       // console.log('TEST', this.previewGeoJSON);
       this.showPreview = true;
   },
   importDXFFile(event, level,buildingId){
       this.readFile(event.target.files[0])
        .then( (data)=>{
            this.dxfOriginalData[level] = data;

           this.mitGisDXFService.extractMapData(data, level, buildingId)
               .then( (dxfMapInfo)=>{

                   this.dxfModels[level] = dxfMapInfo;

                   this.dxfUploadedCount++;

                   // this.spacesMap2 = this.JSONModel.geoJSONbyFloor;
                   //
                   // this.spacesTree = this.JSONModel.spacesTree;
                   // this.spacesMap = this.JSONModel.geoJSON;
                   // this.spacesMapInfo = this.JSONModel.info;
                   // this.spacesList = this.JSONModel.spacesList;
                   // this.spacesDict = this.JSONModel.spacesDict;
                //    console.log('DEBUG dxfMapInfo', dxfMapInfo)
                //    console.log('dxf DEBUG', JSON.stringify(dxfMapInfo.geoJSON));

               });

       });

   },
   importJSONFile(event){
        this.clearData();

        this.readFile(event.target.files[0])
        .then( (data)=>{

            this.mitGisJSONService.extractMapData(JSON.parse(data))
                .then( (buildingData)=>{
                    this.JSONModel = buildingData;
                    //console.log('JSON DEBUG', JSON.stringify(this.JSONModel.geoJSON));
                });


        });


    }
  }
}
</script>

<style lang="scss" scoped>
    .v-stepper__header {
        box-shadow: none;
    }
</style>
